import { AppServiceWebapp } from '@wix/ambassador-app-service-webapp/http';
const appService = AppServiceWebapp('/_api/app-service').Apps();
// const extensionService = AppServiceWebapp('/_api/app-service').Extensions();
export const getAppsData = async ({ appId }) => {
    try {
        const appInfoResponse = await appService().getAppSnapshot({ appId });
        return {
            appComponents: appInfoResponse?.components,
            hasOauthData: appInfoResponse?.authData?.redirectUris?.length
                ? true
                : false,
        };
    }
    catch (err) {
        console.error('error in get apps data', err);
        return { appComponents: [], hasOauthData: false };
    }
};
// export const getExtensions = async () => {
//   try {
//     const extensions = await extensionService().getExtenders({});
//     console.log('extensions', extensions);
//     return extensions.extenders;
//   } catch (err) {
//     console.log('err', err);
//     return [];
//   }
// };
//# sourceMappingURL=appService.js.map